import React from 'react';
import Popup from './Popup';
import './ConfirmDialog.css';

const ConfirmDialog = ({ isOpen, onClose, onConfirm, title, message }) => {
    if (!isOpen) return null;

    return (
        <Popup 
            onClose={onClose}
            title={title}
        >
            <p>{message}</p>
            <div className="popup-buttons">
                <button className="popup-cancel-button" onClick={onClose}>Cancel</button>
                <button className="popup-primary-button danger-button" onClick={onConfirm}>Delete Account</button>
            </div>
        </Popup>
    );
};

export default ConfirmDialog; 